import React from "react"
import Header from "./header"
import CursorTrail from "./cursorTrail"
import siteEffects from "../config/siteEffects"
import "./layout.css"

const Layout = ({
  children,
  headerData,
  isMusic = false,
  showThoughtsNav = false,
  showHeader = true,
}) => {
  const page = (
    <>
      {showHeader && (
        <Header
          headerData={headerData}
          isMusic={isMusic}
          showThoughtsNav={showThoughtsNav}
        />
      )}
      <div style={{}}>
        <main>{children}</main>
      </div>
    </>
  )

  if (isMusic) return page

  return (
    <>
      {siteEffects.cursorTrail && <CursorTrail />}
      <div className="site-content">{page}</div>
    </>
  )
}

export default Layout
